import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import handleKeyPress from '../../../../../../../../common/handleKeyPress';
import imageSources from '../../../../../../../../constants/imageSources/imageSources';
import * as Styled from './styles';

const ClearFormatting = ({ onChange }) => (
    <>
        <Styled.ClearFormattingButtonDiv onClick={onChange} onKeyDown={(e) => handleKeyPress(e, () => onChange(e))}>
            <Styled.ToolbarIcon
                data-test-id="clearFormat"
                data-tip
                data-for="clearFromat"
                src={imageSources.ICONS.CLEAR}
                alt="Clear Formatting"
            />
            <ReactTooltip id="clearFromat" place="top" effect="solid">
                <Styled.MenuButtonIconTooltipText>Clear Formatting</Styled.MenuButtonIconTooltipText>
            </ReactTooltip>
        </Styled.ClearFormattingButtonDiv>
    </>
);

ClearFormatting.propTypes = {
    onChange: PropTypes.func.isRequired,
};

export default ClearFormatting;
